import { useTranslation } from 'react-i18next'
import { Calendar, Eye, Pin, User } from 'lucide-react'
import { Badge } from '@quebon/ui/components/badge'
import { Button } from '@quebon/ui/components/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@quebon/ui/components/dialog'
import type { Announcement } from '@/api/announcements'
import { TiptapViewer } from '@/components/editor/TiptapViewer'

export function AnnouncementDetailModal({
  announcement,
  onClose,
}: {
  announcement: Announcement
  onClose: () => void
}) {
  const { t } = useTranslation(['admin', 'common'])

  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose() }}>
      <DialogContent className="sm:max-w-2xl" showCloseButton={false}>
        <DialogHeader>
          <div className="flex flex-wrap gap-2">
            {announcement.isPinned && (
              <Badge variant="secondary"><Pin />{t('announcement.badge.important')}</Badge>
            )}
            {announcement.source === 'org_admin' && (
              <Badge variant="secondary">{t('announcement.badge.centerAnnouncement')}</Badge>
            )}
          </div>
          <DialogTitle>{announcement.title}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-wrap items-center gap-4 text-sm text-muted-foreground">
          <span className="flex items-center gap-1"><User className="size-4" />{announcement.authorName}</span>
          <span className="flex items-center gap-1"><Calendar className="size-4" />{announcement.createdAt.split('T')[0].replace(/-/g, '.')}</span>
          <span className="flex items-center gap-1"><Eye className="size-4" />{announcement.viewCount}</span>
        </div>
        <TiptapViewer content={announcement.content} />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>{t('common:button.close')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
